/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Carousel, Image } from 'react-bootstrap';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import { useBreakpoint } from '@vlinder-web/breakpoint-hook-widget-react';
import { LeftArrow, RightArrow } from './arrows';
import { BlurBackground, getImageStyle } from '../BlurBackground';
import { PdfViewer } from './pdfViewer';

import './styles.css';

import * as S from './styles';

const DEFAULT_TITLE = 'evidence';

export interface ICarouselItem {
  type: 'img' | 'pdf';
  poster?: string;
  src: string;
  title?: string;
}

export interface ICarouselSectionProps {
  carouselItems?: ICarouselItem[];
  onCarouselImageClick?(item?: ICarouselItem): void;
}

const DEFAULT_PDF_POSTER =
  'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/pdf-illustration.png';

function onWheel(apiObj: scrollVisibilityApiType, ev: React.WheelEvent): void {
  const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

  if (isThouchpad) {
    ev.stopPropagation();
    return;
  }

  if (ev.deltaY < 0) {
    apiObj.scrollNext();
  } else if (ev.deltaY > 0) {
    apiObj.scrollPrev();
  }
}

export const CarouselSection = ({
  carouselItems,
  onCarouselImageClick,
}: ICarouselSectionProps) => {
  const breakpoint = useBreakpoint();
  const _getImageWidth = () => {
    let _style: any = {
      width: '350px',
    };
    if (breakpoint === 'xs' || breakpoint === 'sm') {
      _style.width = '300px';
    }
    return _style;
  };
  const _renderType = (item: ICarouselItem, index: number) => {
    let _comp: any = [];
    if (item?.type === 'img' && item?.src) {
      _comp.push(
        <BlurBackground
          backgroundImage={item.src}
          width={_getImageWidth().width}
          height={'200px'}
          onClick={onCarouselImageClick?.bind(null, item)}
        >
          <Image
            key={`prdv3-carousel-item-img-${index}`}
            src={item.src}
            style={getImageStyle()}
            onClick={onCarouselImageClick?.bind(null, item)}
          />
          {item?.title ?? DEFAULT_TITLE}
        </BlurBackground>
      );
    }
    if (item?.type === 'pdf') {
      const poster = item?.poster ?? DEFAULT_PDF_POSTER;
      _comp.push(
        <BlurBackground
          backgroundImage={poster}
          width={_getImageWidth().width}
          height={'250px'}
          onClick={onCarouselImageClick?.bind(null, item)}
        >
          <PdfViewer file={item?.src} />
          {/* {item?.title ?? DEFAULT_TITLE} */}
          {/* <Image
            key={`prdv3-carousel-item-pdf-${index}`}
            src={poster}
            style={getImageStyle()}
            onClick={onCarouselImageClick?.bind(null, item)}
          /> */}
        </BlurBackground>
      );
    }
    return _comp;
  };

  return (
    <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow} onWheel={onWheel}>
      {carouselItems?.map((item, index) => (
        <div
          key={`pdv3-carousel-item-${index}`}
          style={S.CarouselItemContainer}
        >
          {_renderType(item, index)}
        </div>
      ))}
    </ScrollMenu>
  );
};

CarouselSection.defaultProps = {
  carouselItems: [],
};
